/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'managemenu'} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">調理名機器設定</p>
                </div>
            </div>
        </div>
        <SensorAssignmentCookingName />
    </div>

</template>

<script>
    import SensorAssignmentCookingName from '@/app/components/SensorAssignmentCookingName.vue'
    export default {
        name: 'manageSensorAssignmentCookingName',
        components: {
            SensorAssignmentCookingName
        }
    }
</script>
